import React from "react";
import { Button } from "components/common/Button";
import { useThemedLogo } from "components/hooks/useThemedLogo";

export const VerificationPage = () => {
  const Logo = useThemedLogo();
  return (
    <section className="auth-page">
      <div className="flex flex-col justify-center min-h-full px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="items-center text-center">
            <Logo className="w-18 h-18 mx-auto" aria-label="Logo" />
          </div>
          <h2 className="mt-2 tracking-tight text-center text-fg-title">
            Verification
          </h2>
        </div>
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <p className="text-center text-fg-medium">
            Do you want to permit access to your account?
          </p>
          <div className="mt-6">
            <Button type="button" variant="primary" size="lg" fullWidth={true}>
              Activate
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
